import * as React from "react";
import type { SVGProps } from "react";
const LawFirm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4355_7494)">
      <path
        fill="currentColor"
        d="M15.6911 1.4028c-.537-.537-1.4092-.537-1.9462 0L8.5894 6.5583c-.537.537-.537 1.4092 0 1.9462l.6874.6874c.537.537 1.4092.537 1.9462 0l.1719-.1719 4.5884 4.5842-.1719.1718c-.537.5371-.537 1.4092 0 1.9462l.6874.6874c.5371.5371 1.4092.5371 1.9462 0l5.1555-5.1555c.5371-.537.5371-1.4092 0-1.9462l-.6874-.6874c-.537-.537-1.4091-.537-1.9462 0l-.1718.1719-4.5884-4.5885.1718-.1718c.5371-.537.5371-1.4092 0-1.9462l-.6874-.6874zM9.1608 13.776c-.537-.537-1.4092-.537-1.9462 0l-4.8118 4.8118c-.537.5371-.537 1.4092 0 1.9462l2.0622 2.0623c.537.537 1.4092.537 1.9462 0l4.8118-4.8119c.537-.537.537-1.4091 0-1.9462l-.0601-.0601 2.5262-2.5219-1.9462-1.9462-2.522 2.5219-.0601-.0602z"
      />
    </g>
    <defs>
      <clipPath id="clip0_4355_7494">
        <path fill="transparent" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default LawFirm;
